import { render, staticRenderFns } from "./ProductActivePage.vue?vue&type=template&id=6ca24e4c&scoped=true&"
import script from "./ProductActivePage.vue?vue&type=script&lang=js&"
export * from "./ProductActivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca24e4c",
  null
  
)

export default component.exports